module.exports = __webpack_public_path__ + "img/icon-search.fbdd1be3.svg";